import _ from 'lodash';

const getDiningChanges = (cruiseItinerary, originalCruiseItinerary) => {
  const changes = [];
  if (!cruiseItinerary || !originalCruiseItinerary) {
    return changes;
  }
  _.each(cruiseItinerary.cabins, (cabin, index) => {
    if (originalCruiseItinerary.cabins[index].selectedDiningSeat
      && cabin.selectedDiningSeat
      && originalCruiseItinerary.cabins[index].selectedDiningSeat.diningSeatCode
      !== cabin.selectedDiningSeat.diningSeatCode) {
      changes.push(`Dining changed for stateroom ${cabin.roomIndex + 1}`);
    }
    if (originalCruiseItinerary.cabins[index].selectedDiningTable
      && cabin.selectedDiningTable
      && originalCruiseItinerary.cabins[index].selectedDiningTable.diningTableCode
      !== cabin.selectedDiningTable.diningTableCode) {
      changes.push(`Dining table changed for stateroom ${cabin.roomIndex + 1}`);
    }
  });
  return changes;
};

export default getDiningChanges;
